import type { AiAppCenterModule } from '../types'

export const shortvideoModule: AiAppCenterModule = {
  key: 'shortvideo',
  label: '短视频管理',
  desc: '视频上传 / 内容审核 / 数据统计',
  path: '/shortvideo',
  homePath: '/shortvideo/overview',
  icon: 'ep:video-play',
  color: '#f759ab'
}
